import React, { Component } from "react";
import ReactDOM from 'react-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { bizpost } from "../../ajax";

type Step = "CREDENTIALS" | "OTP_SELECT" | "OTP_VERIFY";
type OtpChannel = "EMAIL" | "SMS";

// interface State {
//   step: Step;
//   email: string;
//   password: string;
//   otp: string;
//   otpChannel: OtpChannel;
//   loading: boolean;
//   resendCountdown: number;
// }

interface State {
  step: Step;
  email: string;
  password: string;
  otp: string;
  otpChannel: OtpChannel;
  loading: boolean;
  resendCountdown: number;
  passwordErrors: string[];
  regulatoryAccepted: boolean;
}

interface PasswordPolicy {
  minLength: number;
  requireUppercase: boolean;
  requireLowercase: boolean;
  requireNumber: boolean;
  requireSpecialChar: boolean;
}

const PASSWORD_POLICY: PasswordPolicy = {
  minLength: 8,
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSpecialChar: true,
};

export class MFALoginMain extends Component<any, State> {
  timer?: NodeJS.Timeout;

  state: State = {
    step: "CREDENTIALS",
    email: "",
    password: "",
    otp: "",
    otpChannel: "EMAIL",
    loading: false,
    resendCountdown: 0,
    passwordErrors: [],
    regulatoryAccepted: false,
  };

  componentWillUnmount() {
    if (this.timer) clearInterval(this.timer);
  }

  startResendTimer = () => {
    this.setState({ resendCountdown: 60 });

    this.timer = setInterval(() => {
      this.setState((prev) => {
        if (prev.resendCountdown <= 1) {
          clearInterval(this.timer);
          return { resendCountdown: 0 };
        }
        return { resendCountdown: prev.resendCountdown - 1 };
      });
    }, 1000);
  };

  handleCredentialSubmit = async() => {
    this.setState({ loading: true });
    try{
      // const {home,apptheme} = this.props;
      const {email, password }  = this.state;
      const json = {s:'security',a:'logon',unm:email,eml:email,pwd:password};
      
      const response = await bizpost(json);
      const {success,em,ed} = response;
      console.log('signin response ',(response||{}).success);
      if(!success){
        const err = ed || {};
        const {message="request failed. user not found",type='warn',title='Login Error'} = err;
        const {onMessage} = this.props;
        if(typeof onMessage === 'function') {onMessage(type,title,message);}
        else {alert(`Login Failed. ${em}`);}
      }
      else{
        this.setState({
          //loading: false,
          step: "OTP_SELECT",
        });
      }
    }
    catch(err){
      const error:any = err || {};
      console.log('login failed: ');
      const {message="request failed",type='warn',title='Login Error'} = error;
      //this.onError(type,title,message);
      const {onMessage} = this.props;
      if(typeof onMessage === 'function') {onMessage(type,title,message);}
      else {alert(`Login Failed. ${err}`);}
    }
    finally{
      this.setState({loading:false});
    }

    // // TODO: Validate credentials with backend
    // setTimeout(() => {
    //   this.setState({
    //     loading: false,
    //     step: "OTP_SELECT",
    //   });
    // }, 1200);
  };

  handleSendOtp = async() => {
    this.setState({ loading: true });

    try{
      // const {home,apptheme} = this.props;
      const {email, password }  = this.state;
      const json = {s:'security',a:'otp',unm:email,eml:email};
      
      const response = await bizpost(json);
      const {success,em,ed} = response;
      console.log('otp response ',(response||{}).success);
      if(!success){
        const err = ed || {};
        const {message="OTP request failed",type='error',title='OTP Error'} = err;
        const {onMessage} = this.props;
        if(typeof onMessage === 'function') {onMessage(type,title,message);}
        else {alert(`Login Failed. ${em}`);}
      }
      else{
        this.setState({
          //loading: false,
          step: "OTP_VERIFY",
          otp: "",
        });
      }
    }
    catch(err){
      const error:any = err || {};
      console.log('otp failed: ');
      const {message="OTP request failed",type='error',title='OTP Error'} = error;
      //this.onError(type,title,message);
      const {onMessage} = this.props;
      if(typeof onMessage === 'function') {onMessage(type,title,message);}
      else {alert(`Request Failed. ${err}`);}
    }
    finally{
      this.setState({loading:false});
    }

    // // TODO: Backend call to send OTP (SMS or Email)
    // setTimeout(() => {
    //   this.setState({
    //     loading: false,
    //     step: "OTP_VERIFY",
    //     otp: "",
    //   });
    //   this.startResendTimer();
    // }, 1000);
  };

  handleVerifyOtp = async() => {
    const {home,apptheme} = this.props;
    this.setState({ loading: true });
    try{
      // const {home,apptheme} = this.props;
      const {otp}  = this.state;
      const json = {s:'security',a:'verify',otp:otp};
      
      const response = await bizpost(json);
      const {success,em,ed} = response;
      console.log('otp response success ',(response||{}).success);
      if(!success){
        const err = ed || {};
        const {message="OTP verification failed.",type='error',title='Verification Error'} = err;
        const {onMessage} = this.props;
        if(typeof onMessage === 'function') {onMessage(type,title,message);}
        else {alert(`Login Failed. ${em}`);}
      }
      else{
        ReactDOM.render(<ThemeProvider theme={apptheme}>{React.createElement(home,{udata:response})}</ThemeProvider>, document.getElementById('app'));
      }
    }
    catch(err){
      const error:any = err || {};
      console.log('login failed: ');
      const {message="OTP verification failed.",type='error',title='Verification Error'} = error;
      //this.onError(type,title,message);
      const {onMessage} = this.props;
      if(typeof onMessage === 'function') {onMessage(type,title,message);}
      else {alert(`Login Failed. ${err}`);}
    }
    finally{
      this.setState({loading:false});
    }

    // // TODO: Backend OTP verification
    // setTimeout(() => {
    //   this.setState({ loading: false });
    //   alert("Authenticated successfully");
    // }, 1200);
  };

  validatePassword = (password: string): string[] => {
    const errors: string[] = [];

    if (password.length < PASSWORD_POLICY.minLength) {
      errors.push(`At least ${PASSWORD_POLICY.minLength} characters`);
    }
    if (PASSWORD_POLICY.requireUppercase && !/[A-Z]/.test(password)) {
      errors.push("At least one uppercase letter");
    }
    if (PASSWORD_POLICY.requireLowercase && !/[a-z]/.test(password)) {
      errors.push("At least one lowercase letter");
    }
    if (PASSWORD_POLICY.requireNumber && !/[0-9]/.test(password)) {
      errors.push("At least one number");
    }
    if (
      PASSWORD_POLICY.requireSpecialChar &&
      !/[!@#$%^&*(),.?":{}|<>]/.test(password)
    ) {
      errors.push("At least one special character");
    }

    return errors;
  }

  renderCredentials0() {
    const { email, password, loading } = this.state;

    return (
      <>
        <TextField
          fullWidth
          label="Email or Username"
          margin="normal"
          value={email}
          onChange={(e) => this.setState({ email: e.target.value })}
        />

        <TextField
          fullWidth
          label="Password"
          type="password"
          margin="normal"
          value={password}
          onChange={(e) => this.setState({ password: e.target.value })}
        />

        <Button
          fullWidth
          variant="contained"
          size="large"
          sx={{ mt: 2 }}
          disabled={!email || !password || loading}
          onClick={this.handleCredentialSubmit}
        >
          {loading ? <CircularProgress size={24} /> : "Continue"}
        </Button>
      </>
    );
  }
  
  renderCredentials() {
    const { email, password, loading, passwordErrors, regulatoryAccepted } =
      this.state;

    return (
      <>
        {this.renderRegulatoryBanner()}

        <TextField
          fullWidth
          label="Email or Username"
          margin="normal"
          value={email}
          onChange={(e) => this.setState({ email: e.target.value })}
          disabled={!regulatoryAccepted}
        />

        <TextField
          fullWidth
          label="Password"
          type="password"
          margin="normal"
          value={password}
          disabled={!regulatoryAccepted}
          onChange={(e) => {
            const pwd = e.target.value;
            this.setState({
              password: pwd,
              passwordErrors: this.validatePassword(pwd),
            });
          }}
        />

        {passwordErrors.length > 0 && (
          <Box sx={{ mt: 1 }}>
            {passwordErrors.map((err) => (
              <Typography key={err} variant="caption" color="error" display="block">
                • {err}
              </Typography>
            ))}
          </Box>
        )}

        <Button
          fullWidth
          variant="contained"
          size="large"
          sx={{ mt: 2 }}
          disabled={
            !email ||
            !password ||
            passwordErrors.length > 0 ||
            loading ||
            !regulatoryAccepted
          }
          onClick={this.handleCredentialSubmit}
        >
          {loading ? <CircularProgress size={24} /> : "Continue"}
        </Button>
      </>
    );
  }

  renderOtpSelector() {
    const { otpChannel, loading } = this.state;

    return (
      <>
        <Typography textAlign="center" mb={2}>
          Select OTP delivery method
        </Typography>

        <ToggleButtonGroup
          fullWidth
          exclusive
          value={otpChannel}
          onChange={(_, value) =>
            value && this.setState({ otpChannel: value })
          }
          sx={{ mb: 2 }}
        >
          <ToggleButton value="EMAIL">Email</ToggleButton>
          <ToggleButton value="SMS">SMS</ToggleButton>
        </ToggleButtonGroup>

        <Button
          fullWidth
          variant="contained"
          size="large"
          disabled={loading}
          onClick={this.handleSendOtp}
        >
          {loading ? <CircularProgress size={24} /> : "Send OTP"}
        </Button>

        <Button
          fullWidth
          variant="text"
          sx={{ mt: 1 }}
          onClick={() => this.setState({ step: "CREDENTIALS" })}
        >
          Back
        </Button>
      </>
    );
  }

  renderOtpVerify() {
    const { otp, loading, resendCountdown, otpChannel } = this.state;

    return (
      <>
        <Typography variant="body2" textAlign="center" mb={2}>
          OTP sent via <strong>{otpChannel}</strong>
        </Typography>

        <TextField
          fullWidth
          label="One-Time Password"
          margin="normal"
          value={otp}
          onChange={(e) => this.setState({ otp: e.target.value })}
          inputProps={{
            maxLength: 6,
            style: { textAlign: "center", letterSpacing: "0.3em" },
          }}
        />

        <Button
          fullWidth
          variant="contained"
          size="large"
          sx={{ mt: 2 }}
          disabled={otp.length !== 6 || loading}
          onClick={this.handleVerifyOtp}
        >
          {loading ? <CircularProgress size={24} /> : "Verify & Login"}
        </Button>

        <Button
          fullWidth
          variant="text"
          sx={{ mt: 1 }}
          disabled={resendCountdown > 0}
          onClick={this.handleSendOtp}
        >
          {resendCountdown > 0
            ? `Resend OTP in ${resendCountdown}s`
            : "Resend OTP"}
        </Button>
      </>
    );
  }

  renderRegulatoryBanner() {
    const { regulatoryAccepted } = this.state;

    return (
      <Box
        sx={{
          bgcolor: "#fef7e0",
          border: "1px solid #f5d77a",
          borderRadius: 2,
          p: 2,
          mb: 3,
        }}
      >
        <Typography variant="caption" color="text.secondary">
          <strong>Regulatory Notice:</strong> This system is monitored and audited.
          Unauthorized access is prohibited and may be prosecuted under applicable
          laws and regulations. By proceeding, you acknowledge compliance with
          data protection, cybersecurity, and usage policies.
        </Typography>

        <Button
          fullWidth
          size="small"
          sx={{ mt: 1 }}
          variant={regulatoryAccepted ? "contained" : "outlined"}
          onClick={() => this.setState({ regulatoryAccepted: true })}
        >
          {regulatoryAccepted ? "Acknowledged" : "Acknowledge & Continue"}
        </Button>
      </Box>
    );
  }

  render() {
    const { step } = this.state;

    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default",
        }}
      >
        <Card sx={{ width: 400, boxShadow: 6 }}>
          <CardContent sx={{ p: 4 }}>
            <Typography
              variant="h5"
              textAlign="center"
              fontWeight={600}
              mb={1}
            >
              Secure Access
            </Typography>

            <Typography
              variant="body2"
              textAlign="center"
              color="text.secondary"
              mb={3}
            >
              Multi-factor authentication required
            </Typography>

            {step === "CREDENTIALS" && this.renderCredentials()}
            {step === "OTP_SELECT" && this.renderOtpSelector()}
            {step === "OTP_VERIFY" && this.renderOtpVerify()}
          </CardContent>
        </Card>
      </Box>
    );
  }
}

export default MFALoginMain;